import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  padding-bottom: 1rem;

  & .mockup-content {
    width: 47.5rem;
    margin: 0 auto;
    padding-top: 1rem;
    max-width: ${({ theme }) => theme.breakpoints.laptopL};
    display: flex;
    flex-direction: column;
  }
`;

export const MockupHeader = styled.header`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.gray2};
  padding: 1.5rem;

  & > .title {
    font-size: 1.625rem;
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: 700;
    margin-bottom: 1.25rem;
  }

  & > .subtitle {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;

export const MockupContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.white};

  & > .title {
    font-size: 1.125rem;
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: 700;
    margin-bottom: 1.25rem;
  }

  & > div {
    & > button {
      &:first-child {
        margin-right: 1.5rem;
      }
    }
    & > .button {
      margin-left: 0.5rem;
      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: 9.75rem;
        justify-content: center;
        align-items: flex-end;
        padding: 0.313rem 1rem;
      }
    }
  }
`;

export const PavementContainer = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  align-items: center;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.grayDark2};
  font-weight: 700;
  border: 0.063rem solid ${({ theme }) => theme.colors.gray5};

  & > header {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 1rem 0;

    & > div {
      width: 51%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 3%;

      & > .pavements {
        font-size: 1rem;
        font-weight: 700;
        margin-bottom: 0;
        margin-right: 1.75rem;
      }

      & > .button {
        display: flex;
        flex-direction: row;
        padding: 0.313rem 0.938rem;
        justify-content: center;
        align-items: center;
        max-width: 11.675rem;
      }
    }

    & > .pavements-status {
      font-size: 1rem;
      font-weight: 700;
      margin-left: 2.5rem;
      margin-bottom: 0;
    }

    & > .pavements-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
`;

export const EditMockupHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1rem 1.5rem 2.4rem 1.5rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-size: 1rem;
  margin-bottom: 1rem;
`;

export const TitleMockupContainer = styled.div`
  padding: 1rem;
`;
